import { useMemo } from 'react';
import { GridRow } from '../../../../../components/grid/shared/types/GridRow';
import { ViewGridColumnOptions } from '../types/ViewGridColumnOptions';
import { ViewGridDataService } from '../services/ViewGridDataService';

export function useViewGridRows(rows: GridRow[] = [], columnsOptions: ViewGridColumnOptions[]): GridRow[] {
  return useMemo(() => ViewGridDataService.getViewRowsFromRows(rows, columnsOptions), [rows, columnsOptions]);
}
